export const apiUrl = process.env.NEXT_PUBLIC_CERBERUS_API_URL;
export const widgetAPIUrl = process.env.NEXT_PUBLIC_WIDGET_API_URL;
export const priceFeedSocketApiUrl = process.env.NEXT_PUBLIC_PRICE_FEED_SOCKET_URL;
export const priceFeedWidgetSocketApiUrl = process.env.NEXT_PUBLIC_PRICE_FEED_WIDGET_SOCKET_URL;
export const dataDogRumClientToken = process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN;
export const dataDogRumApplicationId = process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID;
export const appEnv = process.env.NEXT_PUBLIC_VERCEL_ENV;
export const appVersion = process.env.APP_VERSION ?? '1.0.0';
export const apiAssetsUrl = process.env.NEXT_PUBLIC_ASSETS_URL;
export const supraBaseUrl = 'https://supra.com';
export const dataFeedInactiveDuration = 300;
/* HUBSPOT */
export const hubspotApiUrl = process.env.NEXT_PUBLIC_HUBSPOT_API_URL;
export const hubspotPortalId = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID;
export const hubspotFormId = process.env.NEXT_PUBLIC_HUBSPOT_FORM_ID;
/* Darkly */
export const darklyClientSideId = process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_SIDE_ID;
export const darklySdkId = process.env.NEXT_PUBLIC_LAUNCH_DARKLY_SDK_ID;
/* Password Protect */
export const showPasswordProtect = process.env.NEXT_PUBLIC_SHOW_PASSWORD_PROTECT;
export const passwordProtectValue = process.env.NEXT_PUBLIC_PASSWORD_PROTECT;
/* Wallet Connect */
export const walletConnectProjectId = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID ?? '';
export const starKeyNetworkVersion = process.env.NEXT_PUBLIC_STARKEY_NETWORK_VERSION;
export const walletApiUrl = process.env.NEXT_PUBLIC_WALLET_API_URL;
export const walletKey = process.env.NEXT_PUBLIC_WALLET_KEY;
export const walletAssetsUrl = process.env.NEXT_PUBLIC_WALLET_ASSETS_URL;
